export default "__VITE_ASSET__Cs8h0p2w__ 640w, __VITE_ASSET__CPYm61cv__ 1024w";